import React from "react";
import { cn } from "@/lib/utils";
import { useLanguage } from "@/i18n/LanguageProvider";

// Sleek sliding switch for EN ⇄ ID. Compact, mobile-friendly (≥ 44 px wide
// hit area). Matches the ThemeToggle visual language.
export default function LanguageToggle() {
  const { lang, setLang } = useLanguage();
  const isId = lang === "id";

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isId}
      onClick={() => setLang(isId ? "en" : "id")}
      data-testid="language-toggle"
      aria-label={isId ? "Ganti ke English" : "Switch to Bahasa Indonesia"}
      className={cn(
        "relative inline-flex items-center w-[72px] h-8 rounded-full transition-colors duration-150",
        "border focus:outline-none focus:ring-2 focus:ring-sky-700/30",
        "bg-stone-100 border-stone-200 hover:bg-stone-200"
      )}
    >
      {/* Static labels behind the knob */}
      <span
        className={cn(
          "absolute left-2.5 text-[10px] font-mono font-semibold tracking-wider transition-colors duration-150",
          !isId ? "text-white" : "text-stone-500"
        )}
        data-testid="lang-toggle-en"
      >
        EN
      </span>
      <span
        className={cn(
          "absolute right-2.5 text-[10px] font-mono font-semibold tracking-wider transition-colors duration-150",
          isId ? "text-white" : "text-stone-500"
        )}
        data-testid="lang-toggle-id"
      >
        ID
      </span>

      {/* Sliding pill */}
      <span
        className={cn(
          "absolute top-0.5 h-7 w-[34px] rounded-full bg-sky-700 shadow-sm transition-transform duration-200",
          isId ? "translate-x-[36px]" : "translate-x-0.5"
        )}
        data-testid="lang-toggle-knob"
      />
    </button>
  );
}
